/*
 * @Date: 2025-04-01 17:52:01
 * @Description:工业终端支付管理
 */
import TerminalPay from '../views/industry-terminal-pay.vue';

export const route = [
  {
    path: '/main/industry/terminal-pay',
    name: 'main-industry-terminal-pay',
    meta: {
      title: '终端支付管理'
    },
    component: TerminalPay
  }
];
